module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/experts_mobile-b51b45c2e7fa14238ec37396d94872b9.png";